import {connect} from 'react-redux';
import CustomiseTargetProperty from './CustomiseTargetProperty';
import {updatePreferences} from 'actionCreators/preferences';
import {findSection, updateSectionValue} from 'ducks/reportSections';
import actionCreators from '../actionCreators';
import {updateTargetPhotoList} from 'ducks/propertyDetail';
import PropertyDetailImages from '../lib/PropertyDetailImages';
import {uploadImageToTargetPropertyGalleryList} from 'actionCreators/uploadPropertyImage';

const mapStateToProps = (state) => {
  const reportType = state.reportType.value;
  const property = state.propertyDetail;
  const images = PropertyDetailImages.list(property);

  return {
    reportType,
    section: findSection(state.reportSections, reportType, 'TARGET_PROPERTY'),
    singleLineAddress: property.singleLineAddress,
    bedrooms: property.bedrooms,
    bathrooms: property.bathrooms,
    carSpaces: property.carSpaces,
    landArea: property.landArea,
    floorArea: property.floorArea,
    pageContext: property.pageContext,
    propertyId: property.propertyId,
    dataIsEdited: property.dataIsEdited,
    images,
    selectedPhotoIndex:
      PropertyDetailImages.targetPropertyPhotoList(property)
        .map((url, i) => {
          if (url) {
            const idx = images.indexOf(url);
            return idx === -1 ? i : idx;
          }
          return images.length;
        })
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendEvent: (section, title) => {
      dispatch(actionCreators.sendEditTitleAnalyticsEvent(section, title));
    },
    updateValue: (value, dataKeyPath, reportType) => {
      dispatch(updateSectionValue({
        value,
        reportType,
        key: 'TARGET_PROPERTY',
        dataKeyPath: `sectionData.${ dataKeyPath }`
      }));
    },
    updatePreferences: (preferences, reportType) => {
      dispatch(updatePreferences(preferences, reportType));
    },
    updateTargetPhoto: (index, url) => {
      dispatch(updateTargetPhotoList(index, url, true));
    },
    onUpload: (files, galleryIndex) => dispatch(uploadImageToTargetPropertyGalleryList(files[0], galleryIndex)),
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    updateSectionValue: (value, dataKeyPath) => {
      dispatchProps.updateValue(value, dataKeyPath, stateProps.reportType);
      dispatchProps.sendEvent(stateProps.section, value);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseTargetProperty);